import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Session } from '../../models/auth/session';
import { TokenService } from 'src/app/core/services/auth/token.service';
import { CompanyProfile } from 'src/app/company/models/company/company-profile';
import { RoleGroup } from '../../types/auth/role-group';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private session$ = new BehaviorSubject<Session>(new Session());

  constructor(private router: Router,
    private location: Location,
    private tokenService: TokenService,
    private route: ActivatedRoute) {

    const sessionString = sessionStorage.getItem('session');
    const session = sessionString ? JSON.parse(sessionString) : null;

    if (session != null) {
      this.initiateSession(session);
    } else {
      const loginUrl = '/auth/login';
      let redirectUrl = location.path();
      console.log('session redirectUrl', redirectUrl)
      if (redirectUrl && !this.isLoginUrl(redirectUrl)) {
        redirectUrl = btoa(redirectUrl);
        this.router.navigate([loginUrl], { queryParams: { returnUrl: redirectUrl } });
      } else {
        this.router.navigate([loginUrl]);
      }
    }

    tokenService.token().subscribe(accessToken => {
      const currentSession = JSON.parse(sessionStorage.getItem('session')!);
      currentSession.accessToken = accessToken;
      sessionStorage.setItem('session', JSON.stringify(currentSession));
      this.session$.next(currentSession);
    });
  }

  isLoginUrl(url: string) {
    return url.startsWith("/auth/login");
  }

  session() {
    return this.session$;
  }

  initiateSession(session: Session) {
    if (session != null) {
      sessionStorage.setItem('session', JSON.stringify(session));
      this.session$.next(session);
    }
  }

  updatePhoto(photoUrl: string) {
    const currentSession = JSON.parse(sessionStorage.getItem('session') ?? '');
    currentSession.userProfile.photoUrl = photoUrl;
    sessionStorage.setItem('session', JSON.stringify(currentSession));
    this.session$.next(currentSession);
  }

  updateActiveUserRole(userRole: RoleGroup) {
    const currentSession = JSON.parse(sessionStorage.getItem('session') ?? '');
    currentSession.activeRole = userRole;
    sessionStorage.setItem('session', JSON.stringify(currentSession));
    this.session$.next(currentSession);
  }

  addCompanyName(companyName: string) {
    const currentSession = JSON.parse(sessionStorage.getItem('session') ?? '');
    if (currentSession.companyProfile == null) {
      currentSession.companyProfile = new CompanyProfile();
    }
    currentSession.companyProfile.name = companyName;
    sessionStorage.setItem('session', JSON.stringify(currentSession));
    this.session$.next(currentSession);
  }


  refreshSession(session: any) {
    if (session != null) {
      const currentSession = this.parseSession();
      currentSession.accessToken = session.access_token;
      sessionStorage.setItem('session', JSON.stringify(currentSession));
      this.session$.next(currentSession);
    }
  }

  clearSession() {
    sessionStorage.removeItem('session');
    this.session$.next(new Session());
  }

  parseSession() {
    const sessionString = sessionStorage.getItem('session');
    return sessionString ? JSON.parse(sessionString) : null;
  }
}
